const CARD_FONTS =
  "https://fonts.googleapis.com/css2?family=EB+Garamond:wght@400;700&family=Lato:wght@300;400;700&family=Libre+Caslon+Text:wght@400;700&family=Merriweather:wght@300;400;700&family=Noto+Sans+Georgian:wght@300;400;700&family=Open+Sans:wght@300;400;700&family=Roboto:wght@300;400;700&family=Ubuntu:wght@300;400;700&display=swap";

/** Load the card-designer families only when a designer screen is open. */
export function loadCardFonts() {
  if (typeof document === "undefined") return;
  if (document.querySelector("link[data-connct-card-fonts]")) return;
  const link = document.createElement("link");
  link.rel = "stylesheet";
  link.href = CARD_FONTS;
  link.setAttribute("data-connct-card-fonts", "true");
  document.head.appendChild(link);
}
